import type { AppState } from '@store/types'

import { isCompactLayout, isCompactLayoutEnabled } from './layout'

export const selectArtboardMode = (state: AppState) => state.artboard.mode

export const selectArrowSource = (state: AppState) => state.artboard.arrowSource
export const selectEditingArrowLabel = (state: AppState) =>
  state.artboard.editingArrowLabel

// A label is selected together with its arrow, and the canvas store has many ways
// of dropping that arrow: its label doesn't outlive any of them.
export const selectSelectedArrowLabel = (state: AppState) =>
  state.canvas.arrow.selectedArrowId === state.artboard.selectedArrowLabel
    ? state.artboard.selectedArrowLabel
    : null

export const selectWireframesMultiple = (state: AppState) =>
  state.artboard.wireframesMultiple

// Compact is a saved project layout; other presentation modes retain their own layout.
export const selectCompactLayout = (state: AppState) =>
  isCompactLayout(state.manager.project.settings.tree) &&
  isCompactLayoutEnabled() &&
  !['gallery', 'simple_view', 'seo_mode', 'symbol_library'].includes(
    state.artboard.mode
  )
